import { axiosInstance } from ".."

const trelloProject = async (id) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`/internal/trello/project/${id}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default trelloProject;